"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalProcessBuildIssueEnum = void 0;
var ApprovalProcessBuildIssueEnum;
(function (ApprovalProcessBuildIssueEnum) {
    ApprovalProcessBuildIssueEnum["APPROVER_IS_REQUESTER"] = "APPROVER_IS_REQUESTER";
    ApprovalProcessBuildIssueEnum["FALLBACK_APPROVER_IS_REQUESTER"] = "FALLBACK_APPROVER_IS_REQUESTER";
    ApprovalProcessBuildIssueEnum["FALLBACK_APPROVER_NOT_ENROLLED"] = "FALLBACK_APPROVER_NOT_ENROLLED";
    ApprovalProcessBuildIssueEnum["FINAL_STEP_APPROVERS_NOT_ENROLLED"] = "FINAL_STEP_APPROVERS_NOT_ENROLLED";
    ApprovalProcessBuildIssueEnum["SUPERIOR_NOT_ENROLLED"] = "SUPERIOR_NOT_ENROLLED";
    ApprovalProcessBuildIssueEnum["ALL_STEPS_SKIPPED"] = "ALL_STEPS_SKIPPED";
    ApprovalProcessBuildIssueEnum["ESTIMATED_PAST_STEPS"] = "ESTIMATED_PAST_STEPS";
})(ApprovalProcessBuildIssueEnum = exports.ApprovalProcessBuildIssueEnum || (exports.ApprovalProcessBuildIssueEnum = {}));
